import { colors } from '../theme';

const styles = {
  spinner: {
    display: 'inline-block',
    width: '40px',
    height: '40px',
    border: `4px solid ${colors.gray200}`,
    borderTop: `4px solid ${colors.blue}`,
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem',
  },
  text: {
    marginLeft: '1rem',
    color: colors.midGray,
    fontFamily: "'Avenir Next', 'Helvetica Neue', Helvetica, sans-serif",
  },
};

function LoadingSpinner({ size = 40, text = null, fullScreen = false }) {
  const spinnerSize = size;
  const borderWidth = Math.max(3, size / 10);

  const spinnerStyle = {
    ...styles.spinner,
    width: `${spinnerSize}px`,
    height: `${spinnerSize}px`,
    borderWidth: `${borderWidth}px`,
    borderColor: `${colors.gray200}`,
    borderTopColor: colors.blue,
  };

  const containerStyle = fullScreen
    ? {
        ...styles.container,
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        zIndex: 9999,
      }
    : styles.container;

  return (
    <div style={containerStyle}>
      <div style={spinnerStyle} aria-label="Loading" role="status">
        <span style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', borderWidth: 0 }}>
          Loading...
        </span>
      </div>
      {text && <span style={styles.text}>{text}</span>}
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
}

export default LoadingSpinner;

